module.exports = __webpack_public_path__ + "assets/img/footer_room.6ac1cb51.svg";